import clsx from "clsx";
import { FC } from "react";

import { Planner } from "./Planner";

import { getSidebarHeaderText } from "helpers/sidebar";
import { AccordionTitle } from "mds/components/AccordionTitle";
import { HorizontalDivider } from "mds/components/HorizontalDivider";
import { IconText } from "mds/components/IconText";
import { useIsMdOrLarger } from "mds/hooks/use-responsive";
import { ContactsIcon } from "mds/icons";
import { CONTENT_SIDEBAR_TAB_NAME } from "utils/urls";

export const PlannerInsert: FC<{ startOpen?: boolean }> = ({ startOpen = false }) => {
  const isNarrowScreen = !useIsMdOrLarger();

  const header = (
    <IconText
      className={clsx("font-semibold", !isNarrowScreen && "py-4")}
      iconStart={<ContactsIcon />}
      text={getSidebarHeaderText(CONTENT_SIDEBAR_TAB_NAME.Planner)}
    />
  );

  // Don't hoist: <Planner /> has hooks/state. A module-level element would be reused
  // across mounts and share one Planner instance.
  // react-doctor-disable-next-line react-doctor/rendering-hoist-jsx
  const body = (
    <>
      <HorizontalDivider className="mb-4" />

      <Planner shouldLinkSidebar />
    </>
  );

  return (
    <aside className="w-full min-w-[300px] rounded-xl bg-black-tint-97 px-4 pb-1 md:max-w-[400px]">
      {isNarrowScreen ? (
        <AccordionTitle
          collapsedHeaderClassName="w-full justify-between pt-2 pb-1"
          expandedHeaderClassName="w-full justify-between py-2"
          iconPosition="end"
          startOpen={startOpen}
          title={header}
        >
          {body}
        </AccordionTitle>
      ) : (
        <>
          <h4>{header}</h4>
          {body}
        </>
      )}
    </aside>
  );
};
